module.exports = function (promise, timeout, opts) {
    var Promise     = promise.constructor;
    var rejectWith  = opts && opts.rejectWith;
    var resolveWith = opts && opts.resolveWith;
    var timer;

    var timeoutPromise = new Promise(function (resolve, reject) {
        timer = setTimeout(function () {
            if (rejectWith !== void 0)
                reject(rejectWith);
            else
                resolve(resolveWith);
        }, timeout);
    });

    return Promise.race([timeoutPromise, promise])
        .then(function (value) {
            timer.unref();
            return value;
        }, function (error) {
            timer.unref();
            throw error;
        });
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/time-limit-promise/index.js
// module id = 544
// module chunks = 0